export class Step4 {
    constructor() {}

    intitule = 'stepper.form.mapa_in.step3';
    section1 = 'form.mapa_in.step4_section1';
    getnumlot = 'form.mapa_in.getnumlot';
    getdescription = 'form.mapa_in.getdescription';
    getquantite = 'form.mapa_in.getquantite';
    getdateexecution = 'form.mapa_in.getdateexecution';
    getdatelivraison = 'form.mapa_in.getdatelivraison';
    getmotclef = 'form.mapa_in.getmotclef_liste_avi_';
    getspan4 = 'form.mapa_in.getspan4';
    getunlot = 'form.mapa_in.getunlot';
    getplusieurslot = 'form.mapa_in.getplusieurslot';
    gettouslots = 'form.mapa_in.gettouslots';
    getmarche = 'form.mapa_in.getmarche';
    getoui = 'form.mapa_in.getoui';
    getnon = 'form.mapa_in.getnon';
    add = 'boutons.add';
    remove = 'boutons.remove';

}
